import { PopperBase } from './popper-base';
import { LineOverSchedule } from "../model";
import {
  PLANNER_CLOSE_DIALOG_CREATE_SCHEDULE,
  PLANNER_SHOW_SCHEDULE_TT,
  PLANNER_HIDE_SCHEDULE_TT
} from 'apps/events';
import PopperJS from 'popper.js';

class TooltipSchedule extends PopperBase {
  init(){
    super.init();
    document.addEventListener(PLANNER_SHOW_SCHEDULE_TT, (e) => this.showTooltip(e));
    document.addEventListener(PLANNER_HIDE_SCHEDULE_TT, (e) => this.hideTooltip(e));
  }
  showTooltip(e){
    let overSchedule = e.detail.orders_planner.overSchedule;
    this.isShow = true;
    let popper = new PopperJS(
      overSchedule.element,
      this.querySelector('.popper'),
      this.getPopperOptions()
    );
    this.update();
  }
  hideTooltip(e){
    if(!this.isShow){ return; }
    this.isShow = false;
    this.update();
  }
  onClose(){
    let e = new CustomEvent(PLANNER_CLOSE_DIALOG_CREATE_SCHEDULE, {});
    document.dispatchEvent(e);
  }
}
let scope = 'orders.planner.dialog.tooltip-schedule';
riot.mixin(scope, TooltipSchedule as riot.TagMixin);
